import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IntercomDataTarget from '@/reporting/IntercomDataTarget';
import { useOfferBuilderContext } from '../OfferBuilderContext';
import OfferSummary from '../OfferSummary';
import AboutThisOffer from './AboutThisOffer';
import CustomerReview from './CustomerReview';
import ExistingOfferNotification from './ExistingOfferNotification';
import OfferSubmit from './OfferSubmit';

const OfferReview = () => {
  const { t } = useTranslation();
  const {
    state: { builderVariant },
  } = useOfferBuilderContext();
  const [offerSubmitting, setOfferSubmitting] = useState(false);
  const isDraftVariant = builderVariant === 'draft';

  return (
    <>
      <div className="-mx-4 bg-white px-4 py-6 md:mx-0 md:rounded-md md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row">
          <div className="flex lg:w-7/12">
            <OfferSubmit offerSubmitting={offerSubmitting} setOfferSubmitting={setOfferSubmitting} />
          </div>
          <div className="flex flex-1 flex-col">
            <AboutThisOffer />
          </div>
        </div>
        <div className="mb-6 mt-8 h-[0.5px] bg-stroke/30" />
        <div className="mt-4 flex flex-col gap-6 lg:mt-0 lg:flex-row">
          <div className="space-y-4 lg:w-7/12">
            <div>
              <div className="text-lg font-medium">{t('core.review')}</div>
              <div className="text-sm text-text-secondary">
                {t(
                  builderVariant === 'acquisition'
                    ? 'builder.reviewDescription.acquisition'
                    : 'builder.reviewDescription'
                )}
              </div>
            </div>
            {!isDraftVariant && <ExistingOfferNotification />}
            <CustomerReview offerSubmitting={offerSubmitting} />
          </div>
          <div className="flex-1">
            <IntercomDataTarget className="lg:sticky lg:top-24" target="offerBuilderSummary">
              <div className="mb-2 text-lg font-medium">{t('builder.offerSummary')}</div>
              <OfferSummary offerSubmitting={offerSubmitting} step="review" />
            </IntercomDataTarget>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferReview;
